import React, { useEffect } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard.js";
import jwt_decode from "jwt-decode";
import Protected from "./Pages/Protected";
import SignInV2 from "./Pages/SignInV2";
import Leads from "./Pages/Dashboard/Leads.js";
import Customers from "./Pages/Dashboard/Customers.js";
import AddLead from "./Pages/AdditionalPages/AddLead.js";
import VehicleModels from "./Pages/AdditionalPages/VehicleModels.js";
import Users from "./Pages/AdditionalPages/Users.js";
import { AuthContext } from "./AuthContext.js";
import CallLogs from "./Pages/AdditionalPages/CallLogs.js";
import ChangeLogs from "./Pages/AdditionalPages/ChangeLog.js";
import AdminPanel from "./Pages/AdditionalPages/AdminPanel.js";
import CarFacts from "./Pages/AdditionalPages/CarFacts.js";
import ClosingReasons from "./Pages/AdditionalPages/ClosingReasons.js";
import Reports from "./Pages/AdditionalPages/Reports.js";
import InventoryPage from "./Pages/AdditionalPages/Inventory.js";
import AddCar from "./Pages/AdditionalPages/AddCar.js";
import Blogs from "./Pages/AdditionalPages/Blogs.js";
import BlogEditor from "./Pages/AdditionalPages/BlogEditor.js";
import Enquiries from "./Pages/AdditionalPages/Enquiries.js";
import Prospects from "./Pages/AdditionalPages/Prospects.js";
import PushNotifications from "./Pages/AdditionalPages/PushNotifications.js";

function AppRoute() {
  const { isAuthenticated, authLoading } = React.useContext(AuthContext);
  const jwtVerify = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Token not found"); // You can customize the error message
      }

      let decodedToken = jwt_decode(token);
      let currentDate = new Date();
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        localStorage.clear();
        alert("Session Expired");
      } else {
        console.log("Valid token");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    jwtVerify();
  }, []);

  if (authLoading) {
    return null;
  }

  return (
    <Router>
      <Routes>
        {/* Protected Routes */}
        <Route
          exact
          path="/dashboard"
          element={<Protected Component={Dashboard} />}
        />
        <Route path="/leads" element={<Protected Component={Leads} />} />
        <Route path="/addlead" element={<Protected Component={AddLead} />} />
        <Route
          path="/VehicleModels"
          element={<Protected Component={VehicleModels} />}
        />
        <Route
          path="/Inventory"
          element={<Protected Component={InventoryPage} />}
        />
        <Route
          path="/AddCar"
          element={<Protected Component={AddCar} />}
        />
        <Route
          path="/AddCar/:id"
          element={<Protected Component={AddCar} />}
        />
        <Route path="/Users" element={<Protected Component={Users} />} />
        <Route
          path="/Customers"
          element={<Protected Component={Customers} />}
        />
        <Route path="/callLogs" element={<Protected Component={CallLogs} />} />
        <Route
          path="/changeLogs"
          element={<Protected Component={ChangeLogs} />}
        />
        <Route
          path="/adminPanel"
          element={<Protected Component={AdminPanel} />}
        />
        <Route
          path="/admin/enquiries"
          element={<Protected Component={Enquiries} />}
        />
        <Route path="/carFacts" element={<Protected Component={CarFacts} />} />
        <Route
          path="/closingReasons"
          element={<Protected Component={ClosingReasons} />}
        />
      
        <Route path="/reports" element={<Protected Component={Reports} />} />
        <Route path="/blogs" element={<Protected Component={Blogs} />} />
        <Route path="/blogs/create" element={<Protected Component={BlogEditor} />} />
        <Route path="/blogs/edit/:slug" element={<Protected Component={BlogEditor} />} />
        <Route path="/prospects" element={<Protected Component={Prospects} />} />
        <Route path="/admin/push-notifications" element={<Protected Component={PushNotifications} />} />

        {/* Public Routes */}
        <Route
          exact
          path="/"
          element={
            isAuthenticated ? <Protected Component={Dashboard} /> : <SignInV2 />
          }
        />
      </Routes>
    </Router>
  );
}

export default AppRoute;
